import useBreadcrumbItems, { BreadcrumbItem } from '@xver/hooks/useBreadcrumbItems';
import { useTranslation } from 'react-i18next';

interface ProjectBreadcrumbsProps {
    /** Trailing crumbs after "Account / Projects"; the last one is the current page. */
    trail?: BreadcrumbItem[];
}

export default function ProjectBreadcrumbs({ trail = [] }: ProjectBreadcrumbsProps) {
    const { t } = useTranslation('projects');
    const items = useBreadcrumbItems([
        { title: t('breadcrumb.account'), href: '#' },
        { title: t('breadcrumb.projects'), href: trail.length ? '/projects' : undefined },
        ...trail,
    ]);

    return (
        <nav aria-label={t('breadcrumb.label')} className="mb-6">
            <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm">
                {items.map((item, index) => (
                    <li key={index} className="min-w-0 inline-flex items-center gap-2 break-words">
                        {index > 0 && (
                            <span aria-hidden="true" className="text-fg/68">
                                /
                            </span>
                        )}
                        {item}
                    </li>
                ))}
            </ol>
        </nav>
    );
}
